import fetch from '@/plugin/axios'
// 添加商品
export function getAddd (query) {
  return fetch({
    url: '/api/goods/spu/add',
    method: 'Post',
    data: query
  })
}
// 查询商品
export function getSpuList (query) {
  return fetch({
    url: '/api/goods/spu/list',
    method: 'Post',
    data: query
  })
}
// 下架
export function getOff (id) {
  return fetch({
    url: `/api/goods/spu/down/${id}`,
    method: 'Put'
  })
}
// 上架
export function getPut (id) {
  return fetch({
    url: `/api/goods/spu/up/${id}`,
    method: 'Put'
  })
}
// 钻石品质等级选项
export function getOption () {
  return fetch({
    url: '/api/goods/quality-grade/option',
    method: 'Post'
  })
}
